import LabelInput from 'components/common/forms/LabelInput';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { UserRoleType } from 'types/apis/auth';
import { MypageInfoFormFields } from 'types/form/mypage';

type TProps = {
  role: UserRoleType;
};

const LoginId = ({ role }: TProps) => {
  return (
    <LabelInput
      labelText={role === UserRoleType.STUDENT ? '학번' : '교직원 번호'}
      name={MypageInfoFormFields.LoginId}
      required={true}
      disabled={true}
      inputStyle={{ backgroundColor: STYLES_VARIABLES.GRAY_01 }}
    />
  );
};

export default LoginId;
